/* unplugin-vue-components disabled */"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_2 = { style: { "display": "inline", "margin-left": "5px" } };
const DeleteBtn_1 = tslib_1.__importDefault(require("@/components/DeleteBtn"));
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const work_2 = require("@/store/modules/work");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ToolPanel',
    props: {
        machine: {
            type: model_1.Robot,
            required: true,
        }
    },
    emits: ['addToolClk'],
    setup(__props, { emit: __emit }) {
        const store = (0, work_2.useWork)();
        const emit = __emit;
        const props = __props;
        function handleRemoveTool() {
            store.curDevice.setTool(null);
            let menuNode = { label: model_1.DEVICE_TYPE_NAME.Tool, type: work_1.VIR_NODE_TYPE.N_TAIL, id: props.machine.id + work_1.VIR_NODE_TYPE.N_TAIL, rootId: `${props.machine.id}` };
            store.selectNode(menuNode);
        }
        function onClickAddFixture() {
            emit('addToolClk');
        }
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_popconfirm = (0, vue_2.resolveComponent)("el-popconfirm");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (__props.machine.tool)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_popconfirm, {
                        key: 0,
                        title: "已有夹具装配，继续装配会将原夹具替换！",
                        onConfirm: onClickAddFixture
                    }, {
                        reference: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                style: { "margin-left": "auto" }
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("部件装配")
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                        key: 1,
                        type: "primary",
                        style: { "margin-left": "auto" },
                        onClick: onClickAddFixture
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)(" 部件装配 ")
                        ]),
                        _: 1
                    })),
                (__props.machine.tool)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(DeleteBtn_1.default), {
                        key: 2,
                        title: "确定卸下该夹具吗？",
                        onDelConfirm: handleRemoveTool
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createVNode)(_component_el_button, { type: "" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("卸下")
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        _: 1
                    }))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
